"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayingCard = exports.Requirement = exports.ItemOptional = exports.Item = exports.Coordinates = exports.ProximityEffectCraftCompleteOptional = exports.ProximityEffectOptional = exports.ProximityEffect = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const enum_1 = require("./enum");
class ProximityEffect {
    constructor() {
        Object.defineProperty(this, "distance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Distance at which effect is effectual'),
    __metadata("design:type", Number)
], ProximityEffect.prototype, "distance", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Item provided due to effect'),
    __metadata("design:type", String)
], ProximityEffect.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Number of items provided per second'),
    __metadata("design:type", Number)
], ProximityEffect.prototype, "rate", void 0);
exports.ProximityEffect = ProximityEffect;
class ProximityEffectOptional {
    constructor() {
        Object.defineProperty(this, "distance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Distance at which effect is effectual'),
    __metadata("design:type", Number)
], ProximityEffectOptional.prototype, "distance", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Item provided due to effect'),
    __metadata("design:type", String)
], ProximityEffectOptional.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Number of items provided per second'),
    __metadata("design:type", Number)
], ProximityEffectOptional.prototype, "rate", void 0);
exports.ProximityEffectOptional = ProximityEffectOptional;
class ProximityEffectCraftCompleteOptional {
    constructor() {
        Object.defineProperty(this, "object", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Object or building from which effect was received'),
    __metadata("design:type", String)
], ProximityEffectCraftCompleteOptional.prototype, "object", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Item provided due to effect'),
    __metadata("design:type", String)
], ProximityEffectCraftCompleteOptional.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Number of items provided per second'),
    __metadata("design:type", Number)
], ProximityEffectCraftCompleteOptional.prototype, "quantity", void 0);
exports.ProximityEffectCraftCompleteOptional = ProximityEffectCraftCompleteOptional;
class Coordinates {
    constructor() {
        Object.defineProperty(this, "x", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "y", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('X coordinate'),
    __metadata("design:type", Number)
], Coordinates.prototype, "x", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Y coordinate'),
    __metadata("design:type", Number)
], Coordinates.prototype, "y", void 0);
exports.Coordinates = Coordinates;
class Item {
    constructor() {
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Name of item or currency'),
    __metadata("design:type", String)
], Item.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity of item or currency'),
    __metadata("design:type", Number)
], Item.prototype, "quantity", void 0);
exports.Item = Item;
class ItemOptional {
    constructor() {
        Object.defineProperty(this, "item", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of item or currency'),
    __metadata("design:type", String)
], ItemOptional.prototype, "item", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Quantity of item or currency'),
    __metadata("design:type", Number)
], ItemOptional.prototype, "quantity", void 0);
exports.ItemOptional = ItemOptional;
class Requirement {
    constructor() {
        Object.defineProperty(this, "requirementType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requirementObject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "requirementCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Type of requirement'),
    __metadata("design:type", String)
], Requirement.prototype, "requirementType", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Name of object to be collected or ranked against'),
    __metadata("design:type", String)
], Requirement.prototype, "requirementObject", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Quantity of object required to complete requirement'),
    __metadata("design:type", Number)
], Requirement.prototype, "requirementCount", void 0);
exports.Requirement = Requirement;
class PlayingCard {
    constructor() {
        Object.defineProperty(this, "suit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
}
__decorate([
    (0, class_validator_1.IsEnum)(enum_1.CardSuit),
    (0, class_validator_1.IsIn)(Object.values(enum_1.CardSuit)),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The suit of this particular playing card'),
    __metadata("design:type", String)
], PlayingCard.prototype, "suit", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The number value of this particular playing card'),
    __metadata("design:type", String)
], PlayingCard.prototype, "value", void 0);
exports.PlayingCard = PlayingCard;
